import { getDriverLanguage, normalizeDriverLanguage } from './driverI18n';

const featureText = {
  ja: {
    storageFailure: 'ログイン情報を保存できませんでした。端末の設定を確認して、もう一度お試しください。',
    defaultDriverAnnouncement: 'ここにドライバー向けのお知らせが表示されます。',
    avatarSaveFailed: 'プロフィール写真を保存できませんでした。',
    apiErrorFallback: '処理に失敗しました。もう一度お試しください。',
    apiErrors: { unauthorized: 'ログインの有効期限が切れました。もう一度ログインしてください。', forbidden: 'この操作を行う権限がありません。', not_found: '対象の情報が見つかりません。', timeout: '通信がタイムアウトしました。もう一度お試しください。', chat_not_found: 'チャットが見つかりません。', chat_disabled: 'このチャットは現在利用できません。', user_chat_disabled: 'このチャットは現在利用できません。', driver_not_assigned: 'この予約の担当ドライバーではありません。', invalid_service_issue: '正しい異常項目を選択してください。', message_body_required: 'メッセージを入力してください。' },
    zeroCurrency: '¥0',
    trainingFallback: [{
      id: 'offline-safety',
      title: '安全運行の基本',
      summary: '通信が回復すると、すべての研修内容を再読み込みします。',
      points: ['予約内容と集合場所を確認してください。', '安全を最優先し、異常時はすぐに管理者へ連絡してください。'],
    }],
    certification: {
      title: '乗務認証',
      itemsLabel: '乗務認証項目',
      complete: '資料は完了しています',
      incomplete: '資料が未完了です',
      completeHint: '資料を提出しました。最終審査をお待ちください。',
      incompleteHint: '以下の資料を完了してください。承認後に受注できます。',
      completedCount: '完了',
      needsChanges: '修正が必要',
      personalTitle: '基本情報',
      personalSubtitle: '本人確認書類、連絡先、緊急連絡先',
      personalPending: '入力待ち',
      vehicleTitle: '車両情報',
      vehicleSubtitle: 'ナンバー、車種、車両写真、保険情報',
      vehiclePending: 'アップロード待ち',
      trainingTitle: 'サービス研修',
      trainingSubtitle: '接客基準、安全運転、送迎手順',
      trainingPending: '未学習',
      inspectionTitle: '車両検査・ステッカー',
      inspectionSubtitle: '車両外観、車内清掃、会社表示',
      inspectionPending: '検査待ち',
      finalTitle: 'プラットフォーム最終審査',
      finalSubtitle: '前の項目が完了すると自動提出されます',
      finalPending: '未開放',
    },
    registration: {
      accountRegistration: 'アカウント登録',
      back: 'ログイン選択へ戻る',
      driverTab: 'ドライバー登録',
      fleetTab: 'フリート登録',
      driverTitle: 'ドライバー登録',
      fleetTitle: 'フリート登録',
      driverHint: 'フリートコードを入力すると承認済みのフリートに参加できます。空欄の場合は個人ドライバーとして申請します。',
      fleetHint: '審査中は申請資料の更新のみ可能で、受注や配車はできません。',
      driverSuccess: '登録しました。ログイン後、個人・車両・証明書・研修資料を完成し、最終審査をお待ちください。',
      fleetSuccess: 'フリート申請を提出しました。承認後にフリートログインと固定フリートコードを利用できます。',
      submitFailed: '送信できませんでした。入力内容を確認してください。',
      name: '氏名',
      phone: '携帯電話番号',
      password: 'パスワード（6文字以上）',
      fleetCode: 'フリートコード（任意）',
      fleetCodePlaceholder: 'フリートに参加する場合に入力',
      fleetName: 'フリート名',
      contactName: '責任者名',
      contactPhone: '責任者の携帯電話番号',
      loginPassword: 'ログインパスワード（6文字以上）',
      email: 'メールアドレス',
      companyAddress: '会社住所',
      businessRegistration: '会社登記簿謄本',
      transportPermit: '運送許可証',
      submitting: '送信中…',
      submit: '登録を送信',
    },
    extraSchedule: {
      titleAdd: '予定を追加',
      titleEdit: '追加予定を編集',
      jpy: '日本円 (JPY)',
      cny: '人民元 (CNY)',
      aiTitle: 'AIスマート入力',
      rawPlaceholder: '予約情報を貼り付けてください。日本語、英語、中国語に対応しています。',
      parse: '解析して入力',
      parsing: '解析中…',
      parseDone: '解析しました。内容を確認してください。',
      rawRequired: '予約情報を入力してください',
      parseFailed: 'AI解析に失敗しました。手動で入力してください。',
      missingFields: (names) => `一部の情報を認識できませんでした。手動で入力してください：${names}`,
      manual: 'または手動で入力',
      date: '日付',
      time: '時刻',
      pickup: '出発地',
      destination: '目的地',
      amount: '金額',
      currency: '通貨',
      notes: '備考',
      pickupPlaceholder: '例：東京駅八重洲口',
      destinationPlaceholder: '例：成田空港 T1',
      optional: '任意',
      chooseDate: '日付を選択してください',
      chooseTime: '時刻を選択してください',
      invalidTime: '時刻は HH:mm 形式で入力してください',
      enterPickup: '出発地を入力してください',
      enterDestination: '目的地を入力してください',
      invalidAmount: '正しい金額を入力してください',
      duplicateWarning: '類似する予定があります。重複していないか確認してください：',
      duplicateConfirm: '重複ではないことを確認して保存を続ける',
      duplicateConfirmed: '重複ではないことを確認しました',
      duplicateRequired: '重複ではないことを確認してください',
      cancel: 'キャンセル',
      saving: '保存中…',
      saveEdit: '変更を保存',
      save: '保存する',
      saveFailed: '保存できませんでした。もう一度お試しください。',
      missingFieldNames: { date: '日付', time: '時刻', pickup_location: '出発地', dropoff_location: '目的地', price_amount: '金額' },
    },
    chat: {
      newMessage: '新しいメッセージを受信しました。入力中の内容は保持されます。',
      documentTitle: '新着メッセージ - ドライバーチャット',
      unavailable: 'チャットを開けないか、閲覧権限がありません。',
      loading: '読み込み中…',
      pageTitle: 'チャット',
      back: '予約へ戻る',
    },
    accountDeletion: {
      sectionTitle: 'アカウント管理',
      button: 'アカウントを削除',
      title: 'アカウントを永久に削除',
      warning: 'この操作は取り消せません。プロフィール、証明書、ログイン端末、通知情報が削除され、すぐにログアウトします。',
      fleetWarning: 'フリート管理者アカウントを削除すると、フリートは閉鎖されます。所属ドライバーの個人アカウントは削除されません。',
      password: '現在のパスワード',
      passwordPlaceholder: '現在のパスワードを入力',
      reason: '削除理由（任意）',
      reasonPlaceholder: '任意で理由を入力',
      acknowledge: 'アカウントと個人データが永久に削除され、元に戻せないことを理解しました。',
      cancel: 'キャンセル',
      confirm: '永久に削除',
      deleting: '削除中…',
      passwordRequired: '現在のパスワードを入力してください。',
      acknowledgeRequired: '永久削除の確認にチェックしてください。',
      activeOrder: 'サービス中の予約があります。予約を完了してからアカウントを削除してください。',
      failed: 'アカウントを削除できませんでした。パスワードを確認してください。',
    },
    areas: {
      tokyo: '東京',
      narita_airport: '成田空港',
      haneda_airport: '羽田空港',
      yokohama: '横浜',
      hakone: '箱根',
      fuji: '富士山',
      nikko: '日光',
      kawagoe: '川越',
      kamakura: '鎌倉',
      kanazawa: '金沢',
      shirakawago: '白川郷',
      takayama: '高山',
    },
  },
  en: {
    storageFailure: 'Unable to save your login information. Check the device settings and try again.',
    defaultDriverAnnouncement: 'Driver announcements will appear here.',
    avatarSaveFailed: 'Unable to save the profile photo.',
    apiErrorFallback: 'The request could not be completed. Please try again.',
    apiErrors: { unauthorized: 'Your session has expired. Please sign in again.', forbidden: 'You do not have permission to perform this action.', not_found: 'The requested information could not be found.', timeout: 'The request timed out. Please try again.', chat_not_found: 'The chat could not be found.', chat_disabled: 'This chat is currently unavailable.', user_chat_disabled: 'This chat is currently unavailable.', driver_not_assigned: 'You are not assigned to this order.', invalid_service_issue: 'Select a valid service issue.', message_body_required: 'Enter a message.' },
    zeroCurrency: '¥0',
    trainingFallback: [{
      id: 'offline-safety',
      title: 'Safe Service Essentials',
      summary: 'The complete training program will reload when the connection is restored.',
      points: ['Confirm the order and pickup location before departure.', 'Put safety first and contact dispatch immediately when an issue occurs.'],
    }],
    certification: {
      title: 'Onboarding Verification',
      itemsLabel: 'Onboarding verification items',
      complete: 'Your documents are complete',
      incomplete: 'Your documents are incomplete',
      completeHint: 'Your documents were submitted. Please wait for final review.',
      incompleteHint: 'Complete the items below. You can accept orders after approval.',
      completedCount: 'Completed',
      needsChanges: 'Needs Changes',
      personalTitle: 'Basic Information',
      personalSubtitle: 'Identity documents, contact details, emergency contact',
      personalPending: 'To Complete',
      vehicleTitle: 'Vehicle Information',
      vehicleSubtitle: 'License plate, model, vehicle photos, insurance',
      vehiclePending: 'Upload Required',
      trainingTitle: 'Service Training',
      trainingSubtitle: 'Service standards, safe driving, pickup procedure',
      trainingPending: 'Not Started',
      inspectionTitle: 'Vehicle Inspection & Label',
      inspectionSubtitle: 'Exterior, cabin cleanliness, company identification',
      inspectionPending: 'Inspection Required',
      finalTitle: 'Final Platform Review',
      finalSubtitle: 'Submitted automatically after the previous items are complete',
      finalPending: 'Locked',
    },
    registration: {
      accountRegistration: 'Account Registration',
      back: 'Back to access options',
      driverTab: 'Driver',
      fleetTab: 'Fleet',
      driverTitle: 'Driver Registration',
      fleetTitle: 'Fleet Registration',
      driverHint: 'Enter a fleet code to join an approved fleet, or leave it blank to apply as an independent driver.',
      fleetHint: 'While under review, you can update the application only. Orders and driver assignments remain unavailable.',
      driverSuccess: 'Registration complete. Sign in and finish your personal, vehicle, document, and training information for final review.',
      fleetSuccess: 'Fleet application submitted. Fleet login and a permanent fleet code become available after approval.',
      submitFailed: 'Unable to submit. Check the information and try again.',
      name: 'Full Name',
      phone: 'Mobile Number',
      password: 'Password (at least 6 characters)',
      fleetCode: 'Fleet Code (optional)',
      fleetCodePlaceholder: 'Enter only when joining a fleet',
      fleetName: 'Fleet Name',
      contactName: 'Manager Name',
      contactPhone: 'Manager Mobile Number',
      loginPassword: 'Login Password (at least 6 characters)',
      email: 'Email',
      companyAddress: 'Company Address',
      businessRegistration: 'Company Registration Certificate',
      transportPermit: 'Transport Permit',
      submitting: 'Submitting…',
      submit: 'Submit Registration',
    },
    extraSchedule: {
      titleAdd: 'Add Schedule',
      titleEdit: 'Edit Added Schedule',
      jpy: 'Japanese Yen (JPY)',
      cny: 'Chinese Yuan (CNY)',
      aiTitle: 'AI Smart Fill',
      rawPlaceholder: 'Paste reservation information in English, Japanese, Chinese, or a mixed format.',
      parse: 'Recognize and Fill',
      parsing: 'Recognizing…',
      parseDone: 'Recognition complete. Please verify the information.',
      rawRequired: 'Enter the reservation information.',
      parseFailed: 'AI recognition failed. Please enter the information manually.',
      missingFields: (names) => `Some information was not recognized. Complete these fields manually: ${names}`,
      manual: 'Or enter manually',
      date: 'Date',
      time: 'Time',
      pickup: 'Pickup',
      destination: 'Destination',
      amount: 'Amount',
      currency: 'Currency',
      notes: 'Notes',
      pickupPlaceholder: 'Example: Tokyo Station Yaesu Exit',
      destinationPlaceholder: 'Example: Narita Airport T1',
      optional: 'Optional',
      chooseDate: 'Select a date.',
      chooseTime: 'Select a time.',
      invalidTime: 'Time must use HH:mm format.',
      enterPickup: 'Enter the pickup location.',
      enterDestination: 'Enter the destination.',
      invalidAmount: 'Enter a valid amount.',
      duplicateWarning: 'A similar schedule was found. Confirm that it is not a duplicate:',
      duplicateConfirm: 'This is not a duplicate. Continue saving.',
      duplicateConfirmed: 'Confirmed as not a duplicate',
      duplicateRequired: 'Confirm that this is not a duplicate.',
      cancel: 'Cancel',
      saving: 'Saving…',
      saveEdit: 'Save Changes',
      save: 'Save Schedule',
      saveFailed: 'Unable to save. Please try again.',
      missingFieldNames: { date: 'Date', time: 'Time', pickup_location: 'Pickup', dropoff_location: 'Destination', price_amount: 'Amount' },
    },
    chat: {
      newMessage: 'A new message arrived. Your current draft has been preserved.',
      documentTitle: 'New Message - Driver Chat',
      unavailable: 'The chat is unavailable or you do not have permission to view it.',
      loading: 'Loading…',
      pageTitle: 'Chat',
      back: 'Back to Order',
    },
    accountDeletion: {
      sectionTitle: 'Account Management',
      button: 'Delete Account',
      title: 'Permanently Delete Account',
      warning: 'This cannot be undone. Your profile, documents, login devices, and notification data will be deleted, and you will be signed out immediately.',
      fleetWarning: 'Deleting a fleet owner account closes the fleet. Member drivers keep their own accounts.',
      password: 'Current Password',
      passwordPlaceholder: 'Enter your current password',
      reason: 'Reason (optional)',
      reasonPlaceholder: 'You may tell us why you are leaving',
      acknowledge: 'I understand that my account and personal data will be permanently deleted and cannot be restored.',
      cancel: 'Cancel',
      confirm: 'Delete Permanently',
      deleting: 'Deleting…',
      passwordRequired: 'Enter your current password.',
      acknowledgeRequired: 'Confirm that you understand the permanent deletion.',
      activeOrder: 'An order is currently in service. Complete it before deleting your account.',
      failed: 'Unable to delete the account. Check your password and try again.',
    },
    areas: {
      tokyo: 'Tokyo',
      narita_airport: 'Narita Airport',
      haneda_airport: 'Haneda Airport',
      yokohama: 'Yokohama',
      hakone: 'Hakone',
      fuji: 'Mt. Fuji',
      nikko: 'Nikko',
      kawagoe: 'Kawagoe',
      kamakura: 'Kamakura',
      kanazawa: 'Kanazawa',
      shirakawago: 'Shirakawa-go',
      takayama: 'Takayama',
    },
  },
  zh_cn: {
    storageFailure: '登录信息保存失败，请检查设备设置后重试。',
    defaultDriverAnnouncement: '这里会显示司机端公告。',
    avatarSaveFailed: '头像保存失败，请重试。',
    apiErrorFallback: '操作失败，请重试。',
    apiErrors: { unauthorized: '登录已过期，请重新登录。', forbidden: '你没有权限执行此操作。', not_found: '未找到相关信息。', timeout: '请求超时，请重试。', chat_not_found: '未找到聊天室。', chat_disabled: '聊天室当前不可用。', user_chat_disabled: '聊天室当前不可用。', driver_not_assigned: '你不是此订单的负责司机。', invalid_service_issue: '请选择正确的异常项目。', message_body_required: '请输入消息。' },
    zeroCurrency: '¥0',
    trainingFallback: [{
      id: 'offline-safety',
      title: '安全服务基础',
      summary: '网络恢复后会重新加载完整培训内容。',
      points: ['出发前确认订单和上车地点。', '始终以安全为先，发生异常时立即联系调度。'],
    }],
    certification: {
      title: '上岗认证',
      itemsLabel: '上岗认证项目',
      complete: '资料已完成',
      incomplete: '资料尚未完成',
      completeHint: '资料已提交，请等待平台最终审核。',
      incompleteHint: '请完成以下资料，审核通过后即可开始接单。',
      completedCount: '已完成',
      needsChanges: '需修改',
      personalTitle: '基本资料',
      personalSubtitle: '身份证件、联系方式、紧急联系人',
      personalPending: '待填写',
      vehicleTitle: '车辆资料',
      vehicleSubtitle: '车牌号、车型、车辆照片、保险信息',
      vehiclePending: '待上传',
      trainingTitle: '服务培训',
      trainingSubtitle: '服务规范、安全驾驶、接送流程',
      trainingPending: '未学习',
      inspectionTitle: '车辆检查与贴标',
      inspectionSubtitle: '车辆外观、车内清洁、公司标识',
      inspectionPending: '待检查',
      finalTitle: '平台最终审核',
      finalSubtitle: '完成前面所有项目后自动提交',
      finalPending: '未开放',
    },
    registration: {
      accountRegistration: '账户注册',
      back: '返回登录入口',
      driverTab: '司机注册',
      fleetTab: '车队注册',
      driverTitle: '司机注册',
      fleetTitle: '车队注册',
      driverHint: '填写车队码可加入已开通车队；不填写则按独立司机申请。',
      fleetHint: '车队审核前只能补充申请资料，不能收单或分配司机。',
      driverSuccess: '注册成功。请登录完成个人、车辆、证件和培训资料，等待总部审核。',
      fleetSuccess: '车队申请已提交。总部审核通过后可使用车队登录，并获得永久车队码。',
      submitFailed: '提交失败，请检查资料后重试。',
      name: '姓名',
      phone: '手机号',
      password: '密码（至少 6 位）',
      fleetCode: '车队码（可选）',
      fleetCodePlaceholder: '加入车队时填写',
      fleetName: '车队名称',
      contactName: '负责人姓名',
      contactPhone: '负责人手机号',
      loginPassword: '登录密码（至少 6 位）',
      email: '邮箱',
      companyAddress: '公司地址',
      businessRegistration: '公司营业登记证明（登記簿謄本）',
      transportPermit: '运输许可',
      submitting: '提交中…',
      submit: '提交注册',
    },
    extraSchedule: {
      titleAdd: '追加排班',
      titleEdit: '编辑追加排班',
      jpy: '日元 (JPY)',
      cny: '人民币 (CNY)',
      aiTitle: 'AI 智能识别',
      rawPlaceholder: '粘贴预约信息，支持中文、英文或混合格式。',
      parse: '识别并填充',
      parsing: '识别中…',
      parseDone: '识别完成，请核对信息。',
      rawRequired: '请输入预约信息。',
      parseFailed: 'AI 识别失败，请手动输入。',
      missingFields: (names) => `部分信息未能识别，请手动补充：${names}`,
      manual: '或手动填写',
      date: '日期',
      time: '时间',
      pickup: '出发地',
      destination: '目的地',
      amount: '金额',
      currency: '币种',
      notes: '备注',
      pickupPlaceholder: '例：东京站八重洲口',
      destinationPlaceholder: '例：成田机场 T1',
      optional: '可选',
      chooseDate: '请选择日期。',
      chooseTime: '请选择时间。',
      invalidTime: '时间格式必须为 HH:mm。',
      enterPickup: '请输入出发地。',
      enterDestination: '请输入目的地。',
      invalidAmount: '请输入有效金额。',
      duplicateWarning: '发现相似排班，请确认是否重复：',
      duplicateConfirm: '确认不是重复，继续保存',
      duplicateConfirmed: '已确认不是重复排班',
      duplicateRequired: '请先确认排班不是重复的。',
      cancel: '取消',
      saving: '保存中…',
      saveEdit: '保存修改',
      save: '确认保存',
      saveFailed: '保存失败，请重试。',
      missingFieldNames: { date: '日期', time: '时间', pickup_location: '出发地', dropoff_location: '目的地', price_amount: '金额' },
    },
    chat: {
      newMessage: '收到新消息，当前输入内容不会被清空。',
      documentTitle: '新消息 - 司机聊天室',
      unavailable: '聊天室不可用或无权查看。',
      loading: '加载中…',
      pageTitle: '聊天室',
      back: '返回订单',
    },
    accountDeletion: {
      sectionTitle: '账号管理',
      button: '删除账号',
      title: '永久删除账号',
      warning: '此操作无法撤销。个人资料、证件、登录设备和通知信息会被删除，并立即退出登录。',
      fleetWarning: '删除车队主账号会同时关闭车队，但不会删除旗下司机的个人账号。',
      password: '当前密码',
      passwordPlaceholder: '请输入当前密码',
      reason: '删除原因（可选）',
      reasonPlaceholder: '可以填写离开的原因',
      acknowledge: '我已了解账号和个人数据将被永久删除，并且无法恢复。',
      cancel: '取消',
      confirm: '永久删除',
      deleting: '删除中…',
      passwordRequired: '请输入当前密码。',
      acknowledgeRequired: '请确认你已了解永久删除的后果。',
      activeOrder: '当前仍有服务中的订单，请完成订单后再删除账号。',
      failed: '账号删除失败，请检查密码后重试。',
    },
    areas: {
      tokyo: '东京',
      narita_airport: '成田机场',
      haneda_airport: '羽田机场',
      yokohama: '横滨',
      hakone: '箱根',
      fuji: '富士山',
      nikko: '日光',
      kawagoe: '川越',
      kamakura: '镰仓',
      kanazawa: '金泽',
      shirakawago: '白川乡',
      takayama: '高山',
    },
  },
  zh_tw: {
    storageFailure: '登入資訊儲存失敗，請檢查裝置設定後重試。',
    defaultDriverAnnouncement: '這裡會顯示司機端公告。',
    avatarSaveFailed: '頭像儲存失敗，請重試。',
    apiErrorFallback: '操作失敗，請重試。',
    apiErrors: { unauthorized: '登入已過期，請重新登入。', forbidden: '你沒有權限執行此操作。', not_found: '未找到相關資訊。', timeout: '請求逾時，請重試。', chat_not_found: '未找到聊天室。', chat_disabled: '聊天室目前無法使用。', user_chat_disabled: '聊天室目前無法使用。', driver_not_assigned: '你不是此訂單的負責司機。', invalid_service_issue: '請選擇正確的異常項目。', message_body_required: '請輸入訊息。' },
    zeroCurrency: '¥0',
    trainingFallback: [{
      id: 'offline-safety',
      title: '安全服務基礎',
      summary: '網路恢復後會重新載入完整培訓內容。',
      points: ['出發前確認訂單和上車地點。', '始終以安全為先，發生異常時立即聯絡調度。'],
    }],
    certification: {
      title: '上崗認證',
      itemsLabel: '上崗認證項目',
      complete: '資料已完成',
      incomplete: '資料尚未完成',
      completeHint: '資料已提交，請等待平台最終審核。',
      incompleteHint: '請完成以下資料，審核通過後即可開始接單。',
      completedCount: '已完成',
      needsChanges: '需修改',
      personalTitle: '基本資料',
      personalSubtitle: '身分證件、聯絡方式、緊急聯絡人',
      personalPending: '待填寫',
      vehicleTitle: '車輛資料',
      vehicleSubtitle: '車牌號、車型、車輛照片、保險資訊',
      vehiclePending: '待上傳',
      trainingTitle: '服務培訓',
      trainingSubtitle: '服務規範、安全駕駛、接送流程',
      trainingPending: '未學習',
      inspectionTitle: '車輛檢查與貼標',
      inspectionSubtitle: '車輛外觀、車內清潔、公司標識',
      inspectionPending: '待檢查',
      finalTitle: '平台最終審核',
      finalSubtitle: '完成前面所有項目後自動提交',
      finalPending: '未開放',
    },
    registration: {
      accountRegistration: '帳號註冊',
      back: '返回登入入口',
      driverTab: '司機註冊',
      fleetTab: '車隊註冊',
      driverTitle: '司機註冊',
      fleetTitle: '車隊註冊',
      driverHint: '填寫車隊碼可加入已開通車隊；不填寫則以獨立司機身分申請。',
      fleetHint: '車隊審核前只能補充申請資料，不能接單或分配司機。',
      driverSuccess: '註冊成功。請登入完成個人、車輛、證件和培訓資料，等待總部審核。',
      fleetSuccess: '車隊申請已提交。總部審核通過後可使用車隊登入，並取得永久車隊碼。',
      submitFailed: '提交失敗，請檢查資料後重試。',
      name: '姓名',
      phone: '手機號碼',
      password: '密碼（至少 6 位）',
      fleetCode: '車隊碼（選填）',
      fleetCodePlaceholder: '加入車隊時填寫',
      fleetName: '車隊名稱',
      contactName: '負責人姓名',
      contactPhone: '負責人手機號碼',
      loginPassword: '登入密碼（至少 6 位）',
      email: '電子郵件',
      companyAddress: '公司地址',
      businessRegistration: '公司營業登記證明（登記簿謄本）',
      transportPermit: '運輸許可',
      submitting: '提交中…',
      submit: '提交註冊',
    },
    extraSchedule: {
      titleAdd: '新增排班',
      titleEdit: '編輯新增排班',
      jpy: '日圓 (JPY)',
      cny: '人民幣 (CNY)',
      aiTitle: 'AI 智慧辨識',
      rawPlaceholder: '貼上預約資訊，支援中文、英文或混合格式。',
      parse: '辨識並填入',
      parsing: '辨識中…',
      parseDone: '辨識完成，請核對資訊。',
      rawRequired: '請輸入預約資訊。',
      parseFailed: 'AI 辨識失敗，請手動輸入。',
      missingFields: (names) => `部分資訊未能辨識，請手動補充：${names}`,
      manual: '或手動填寫',
      date: '日期',
      time: '時間',
      pickup: '出發地',
      destination: '目的地',
      amount: '金額',
      currency: '幣別',
      notes: '備註',
      pickupPlaceholder: '例：東京站八重洲口',
      destinationPlaceholder: '例：成田機場 T1',
      optional: '選填',
      chooseDate: '請選擇日期。',
      chooseTime: '請選擇時間。',
      invalidTime: '時間格式必須為 HH:mm。',
      enterPickup: '請輸入出發地。',
      enterDestination: '請輸入目的地。',
      invalidAmount: '請輸入有效金額。',
      duplicateWarning: '發現相似排班，請確認是否重複：',
      duplicateConfirm: '確認不是重複，繼續儲存',
      duplicateConfirmed: '已確認不是重複排班',
      duplicateRequired: '請先確認排班不是重複的。',
      cancel: '取消',
      saving: '儲存中…',
      saveEdit: '儲存修改',
      save: '確認儲存',
      saveFailed: '儲存失敗，請重試。',
      missingFieldNames: { date: '日期', time: '時間', pickup_location: '出發地', dropoff_location: '目的地', price_amount: '金額' },
    },
    chat: {
      newMessage: '收到新訊息，目前輸入內容不會被清除。',
      documentTitle: '新訊息 - 司機聊天室',
      unavailable: '聊天室無法使用或無權查看。',
      loading: '載入中…',
      pageTitle: '聊天室',
      back: '返回訂單',
    },
    accountDeletion: {
      sectionTitle: '帳號管理',
      button: '刪除帳號',
      title: '永久刪除帳號',
      warning: '此操作無法復原。個人資料、證件、登入裝置和通知資訊會被刪除，並立即登出。',
      fleetWarning: '刪除車隊主帳號會同時關閉車隊，但不會刪除旗下司機的個人帳號。',
      password: '目前密碼',
      passwordPlaceholder: '請輸入目前密碼',
      reason: '刪除原因（選填）',
      reasonPlaceholder: '可以填寫離開的原因',
      acknowledge: '我已了解帳號和個人資料將被永久刪除，而且無法復原。',
      cancel: '取消',
      confirm: '永久刪除',
      deleting: '刪除中…',
      passwordRequired: '請輸入目前密碼。',
      acknowledgeRequired: '請確認你已了解永久刪除的後果。',
      activeOrder: '目前仍有服務中的訂單，請完成訂單後再刪除帳號。',
      failed: '帳號刪除失敗，請檢查密碼後重試。',
    },
    areas: {
      tokyo: '東京',
      narita_airport: '成田機場',
      haneda_airport: '羽田機場',
      yokohama: '橫濱',
      hakone: '箱根',
      fuji: '富士山',
      nikko: '日光',
      kawagoe: '川越',
      kamakura: '鎌倉',
      kanazawa: '金澤',
      shirakawago: '白川鄉',
      takayama: '高山',
    },
  },
};

export function getDriverFeatureText(language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  return featureText[normalized] || featureText.zh_cn;
}

export function getLocalizedDriverApiError(error, fallback, language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  const copy = getDriverFeatureText(normalized);
  const status = Number(error?.response?.status || 0);
  const detail = error?.response?.data?.detail;
  const explicitCode = error?.response?.data?.error_code || error?.response?.data?.code;
  const detailCode = typeof detail === 'string' && /^[a-z0-9_]+$/i.test(detail.trim()) ? detail.trim().toLowerCase() : '';
  const statusCode = status === 401 ? 'unauthorized' : status === 403 ? 'forbidden' : status === 404 ? 'not_found' : '';
  const networkCode = error?.code === 'ECONNABORTED' || String(error?.message || '').toLowerCase().includes('timeout') ? 'timeout' : '';
  const code = String(explicitCode || detailCode || statusCode || networkCode || '').toLowerCase();
  return copy.apiErrors?.[code] || fallback || copy.apiErrorFallback;
}

export function getLocalizedDriverAnnouncement(value, language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  const announcement = String(value || '').trim();
  if (!announcement) return '';
  if (announcement === '这里可以发布司机端公告。') {
    return getDriverFeatureText(normalized).defaultDriverAnnouncement;
  }
  return announcement;
}

export function validateDriverFeatureTextCatalogs() {
  const expected = Object.keys(featureText.en).sort().join("|");
  Object.entries(featureText).forEach(([language, catalog]) => {
    if (Object.keys(catalog).sort().join("|") !== expected) {
      throw new Error(`driver_feature_translation_keys_mismatch:${language}`);
    }
  });
  return true;
}

export { featureText };
